// @flow

import {useMemo} from 'react';
import {useTypedSelector} from '../../../../store';
import {useIsFeatureInTier} from '../../../../utils/component';

const DEFAULT_ADDITIONAL_INPUTS = [
  'Documento de identidad',
  'Fecha de entrega',
  'Comentario',
  'Información adicional',
];

export const useAdditionalInformation = () => {
  const hasCustomCheckoutFeature = useIsFeatureInTier('CUSTOM_ORDER_CHECKOUT');

  const additionalInformation = useTypedSelector(
    state => state.salesProcessConfig.salesProcessInformation
  );

  const identityNumberInput = useMemo(() => {
    if (additionalInformation) {
      return additionalInformation.find(
        e => e.enabled && e.name === 'Documento de identidad'
      );
    }
  }, [additionalInformation]);

  const deliveryDateInput = useMemo(() => {
    if (additionalInformation) {
      return additionalInformation.find(
        e => e.enabled && e.name === 'Fecha de entrega'
      );
    }
  }, [additionalInformation]);

  const commentInput = useMemo(() => {
    if (additionalInformation) {
      return additionalInformation.find(
        e =>
          e.enabled && ['Comentario', 'Información adicional'].includes(e.name)
      );
    }
  }, [additionalInformation]);

  const defaultAdditionalInformation = useMemo(() => {
    if (additionalInformation) {
      const enabledAddInformation = additionalInformation.filter(
        el => el.enabled
      );
      if (hasCustomCheckoutFeature) return enabledAddInformation;
      else
        return enabledAddInformation.filter(
          ip => ip.enabled && DEFAULT_ADDITIONAL_INPUTS.includes(ip.name)
        );
    }
  }, [additionalInformation, hasCustomCheckoutFeature]);

  return useMemo(
    () => ({
      additionalInformation: defaultAdditionalInformation,
      identityNumberInput,
      deliveryDateInput,
      commentInput,
    }),
    [
      commentInput,
      defaultAdditionalInformation,
      deliveryDateInput,
      identityNumberInput,
    ]
  );
};
